import React, { FC } from 'react'

import icon2 from '@/screens/promo-iphone-17/ui/assets/icon-1.svg'
import icon3 from '@/screens/promo-iphone-17/ui/assets/icon-2.svg'
import icon4 from '@/screens/promo-iphone-17/ui/assets/icon-3.svg'
import icon1 from '@/screens/promo-iphone-17/ui/assets/icon.svg'

import { Icon } from '@/shared/ui/icon'

import cl from './WhyPort.module.scss'

export interface WhyPortProps {
	title?: string
	list?: {
		title: string
		titleColor: string
		subtitle: string
		src: string
	}[]
}

export const whyPortItems = {
	title: 'Почему iPort',
	list: [
		{
			title: 'Оригинальная техника',
			titleColor: '#000',
			subtitle: 'Товар официально ввезён в Россию',
			src: icon1
		},
		{
			titleColor: '#000',
			title: 'Обслуживание с гарантией качества',
			subtitle: 'Собственные сервисные центры',
			src: icon2
		},
		{
			titleColor: '#000',
			title: 'Поддержка экспертов',
			subtitle: 'От выбора устройства до настроек',
			src: icon3
		},
		{
			titleColor: '#000',
			title: 'Гарантия 2 года',
			subtitle: 'Расширенная защита на всю продукцию Apple',
			src: icon4
		}
	]
}

export const WhyPort: FC<WhyPortProps> = () => {
	const { list, title } = whyPortItems
	return (
		<section className={cl.root}>
			<h2>{title}</h2>
			<ul>
				{list.map(({ subtitle, src, title, titleColor }) => (
					<li key={title}>
						<div className={cl.textWrapper}>
							<Icon icon={src} width={80} height={80} className={cl.icon} />
							<h4 style={{ backgroundImage: titleColor }}>{title}</h4>
							<p>{subtitle}</p>
						</div>
					</li>
				))}
			</ul>
		</section>
	)
}
